module.exports = __webpack_public_path__ + "static/img/xubin.199dbc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/xubin.png
// module id = 7I7f
// module chunks = 0